import React, { forwardRef } from 'react';
import { Tooltip } from 'antd';
import styles from './ToolButton.module.css';

/**
 * 32px ghost icon button for the header's tool strip. Extra props (such as the
 * ones a wrapping Dropdown adds) go to the button; a passed className is added
 * to ours, never in place of it.
 */
const ToolButton = forwardRef(function ToolButton({ title, className = '', children, ...buttonProps }, ref) {
    return (
        <Tooltip title={title} placement="bottom">
            <button
                ref={ref}
                type="button"
                className={`${styles.button} ${className}`.trim()}
                aria-label={title}
                {...buttonProps}
            >
                {children}
            </button>
        </Tooltip>
    );
});

export default ToolButton;
